import { brandMarkPath } from "../components/common/BrandLockup";
import { Footer } from "../components/common/Footer";
import { beautyPublicPricingCards } from "../constants/pricing";

export function PricingPage() {
  return (
    <div className="go-beauty">
      <nav className="gb-nav">
        <a className="gb-brand" href="/go" aria-label="THH GO">
          <img className="gb-logo" src={brandMarkPath} alt="" aria-hidden="true" />
          <small>GO</small>
        </a>
        <div className="gb-navlinks">
          <a href="#beauty-pricing">Beauty</a>
          <a href="#future-pricing">Outras verticais</a>
          <a href="/beauty" className="gb-navcta">Ver Beauty</a>
        </div>
      </nav>

      <section className="gb-hero">
        <div className="gb-hero-copy">
          <p className="gb-eyebrow">Planos por vertical</p>
          <h1>Cada vertical tem sua lógica comercial.</h1>
          <p>
            O THH GO não trabalha com uma tabela única para qualquer operação. Beauty já tem preço
            publicado porque abriu a oferta inicial. As outras verticais entram com jornada própria, validação
            controlada e estrutura comercial separada.
          </p>
          <div className="gb-actions">
            <a className="gb-primary" href="/beauty">Ver página de Beauty</a>
            <a className="gb-secondary" href="/go/start">Falar com o THH GO</a>
          </div>
          <div className="gb-trust">
            <span>Preço publicado para Beauty</span>
            <span>Operações maiores com entrada assistida</span>
            <span>Expansão por vertical, não por improviso</span>
          </div>
        </div>

        <div className="gb-board" aria-label="Resumo comercial">
          <div className="gb-board-head">
            <div>
              <span>Como ler esta página</span>
              <strong>Preço ativo onde já existe vertical ativa</strong>
            </div>
            <em>Beauty agora</em>
          </div>
          <div className="gb-metrics">
            <div>
              <strong>01</strong>
              <span>vertical com oferta pública atual</span>
            </div>
            <div>
              <strong>03</strong>
              <span>verticais em evolução controlada</span>
            </div>
            <div>
              <strong>0</strong>
              <span>tabela genérica para todo tipo de operação</span>
            </div>
          </div>
          <div className="gb-schedule">
            <div className="gb-slot">
              <time>Beauty</time>
              <div>
                <strong>Preço claro para começar</strong>
                <span>Solo e Team publicados. Studio e Studio+ seguem com apoio comercial.</span>
              </div>
              <em>ativo</em>
            </div>
            <div className="gb-slot">
              <time>Health</time>
              <div>
                <strong>Sem preço público agora</strong>
                <span>Entrada controlada até existir validação e recorte comercial maduros.</span>
              </div>
              <em>futuro</em>
            </div>
            <div className="gb-slot">
              <time>Legal</time>
              <div>
                <strong>Sem copiar Beauty por atalho</strong>
                <span>Carteira, prazo e operação jurídica pedem oferta própria quando a hora chegar.</span>
              </div>
              <em>futuro</em>
            </div>
          </div>
          <p className="gb-note">
            Quando uma nova vertical abrir, ela entra com página, linguagem e preço próprios. Esta
            rota existe para orientar a entrada atual, não para fingir universalidade.
          </p>
        </div>
      </section>

      <section className="gb-section gb-pricing" id="beauty-pricing">
        <div className="gb-section-head">
          <p className="gb-eyebrow">Beauty</p>
          <h2>Preço publicado para a vertical que já está em campo.</h2>
          <p>
            Beauty abriu a oferta comercial inicial. Por isso os planos ativos e a narrativa de valor pública
            começam aqui.
          </p>
        </div>
        <div className="gb-price-grid">
          {beautyPublicPricingCards.map((plan) => (
            <article key={plan.id} className={`gb-price-card${plan.variant ? ` ${plan.variant}` : ""}`}>
              <span>{plan.label}</span>
              <h3>
                {plan.priceLabel}
                {plan.periodLabel ? <small>{plan.periodLabel}</small> : null}
              </h3>
              <p>{plan.description}</p>
              <ul>
                {plan.features.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
              <a href={plan.href}>{plan.ctaLabel}</a>
            </article>
          ))}
        </div>
      </section>

      <section className="gb-section gb-settings" id="future-pricing">
        <div className="gb-section-head">
          <p className="gb-eyebrow">Outras verticais</p>
          <h2>Health, Legal e próximas entradas não herdam o preço de Beauty.</h2>
          <p>
            Cada vertical precisa abrir com oferta própria, coerente com dor, risco e valor percebido
            do segmento. O THH GO cresce por especialização, não por tabela genérica.
          </p>
        </div>
        <div className="gb-cards">
          <article className="gb-card">
            <strong>Health</strong>
            <p>Sem preço público agora. Entrada controlada quando a jornada estiver madura e segura.</p>
          </article>
          <article className="gb-card">
            <strong>Legal</strong>
            <p>Carteira e prazo pedem oferta própria. Não faz sentido espelhar a lógica de Beauty.</p>
          </article>
          <article className="gb-card">
            <strong>Oficinas</strong>
            <p>Candidata em validação. A rota comercial nasce quando houver clareza de operação e proposta.</p>
          </article>
          <article className="gb-card">
            <strong>Regra comercial</strong>
            <p>Preço por vertical, com linguagem, limites e entrada aderentes ao recorte real.</p>
          </article>
        </div>
      </section>

      <section className="gb-final">
        <p className="gb-eyebrow">Entrada atual</p>
        <h2>Se o seu negócio é Beauty, aqui já existe caminho claro.</h2>
        <p>
          Para as demais verticais, o caminho certo ainda é conversa e validação. Para Beauty, já dá
          para entender plano, valor e ponto de partida sem ambiguidade.
        </p>
        <div className="gb-actions">
          <a className="gb-primary" href="/beauty">Conhecer Beauty</a>
          <a className="gb-secondary" href="/go/start">Falar com o THH GO</a>
        </div>
      </section>

      <Footer
        brand="THH GO"
        message="THH — Preço e entrada respeitam a lógica de cada vertical"
        links={[
          { href: "/beauty", label: "Beauty" },
          { href: "/go", label: "THH GO" },
          { href: "/", label: "THH" }
        ]}
      />
    </div>
  );
}
